import {
    get_ajax_url,
    fetch_fresh_nonce,
    get_nonce,
} from "./runtime-credentials";
import {
    getDomain,
    getDomainName,
    getDomainUppercase,
    getFirebaseConfig,
    getImgUrl,
    getImgUrlGeneral,
    getJsTranslations,
    getLocale,
    getLiveUpdateLoaderMarkup,
    getPermalink,
    getPostId,
    getServiceSimplyBook,
    getStatusSimplyBook,
    getTemplateName,
    getThemeUri,
} from "../services/site-vars";

const get_post_id = getPostId;
const get_error_message = (key) => $("#error-message-" + key + "").addClass('active');
const get_img_url = getImgUrl;
const get_permalink = getPermalink;
const get_service_simply_book = getServiceSimplyBook;
const get_status_simply_book = getStatusSimplyBook;
const get_template_name = getTemplateName;
const get_domain = getDomain;
const get_domain_uppercase = getDomainUppercase;
const get_img_url_general = getImgUrlGeneral;
const get_domain_name = getDomainName;
const get_firebase_config = getFirebaseConfig;
const get_js_translations = getJsTranslations;
const get_locale = getLocale;
const get_live_update_loader_markup = getLiveUpdateLoaderMarkup;
const get_theme_uri = getThemeUri;

export default {
    get_ajax_url,
    get_nonce,
    fetch_fresh_nonce,
    get_post_id,
    get_error_message,
    get_img_url,
    get_permalink,
    get_service_simply_book,
    get_status_simply_book,
    get_template_name,
    get_domain,
    get_domain_uppercase,
    get_img_url_general,
    get_domain_name,
    get_firebase_config,
    get_js_translations,
    get_locale,
    get_live_update_loader_markup,
    get_theme_uri,
};
